import {
  Component,
  OnInit,
  Input,
  ChangeDetectorRef,
  OnChanges,
} from '@angular/core';
import { navItems } from './sidebar-data';
import { Router } from '@angular/router';
import { NavService } from '../../../../services/nav.service';
import { MediaMatcher } from '@angular/cdk/layout';
import { AppHorizontalNavItemComponent } from './nav-item/nav-item.component';
import { CommonModule, NgForOf, NgIf } from '@angular/common';
import { SidebarService } from './sidebar.service';
import { NavItem } from '../../vertical/sidebar/nav-item/nav-item';
import { CluPermissionModule } from 'src/app/utils/clu-permission/clu-permission.module';
import { AuthService } from 'src/app/@auth/auth.service';
import { AuthSessionDto, ROLE_WORKSPACE_USER } from 'src/app/app.models';

@Component({
  selector: 'app-horizontal-sidebar',
  standalone: true,
  imports: [AppHorizontalNavItemComponent, NgIf, NgForOf, CommonModule, CluPermissionModule],
  providers: [SidebarService],
  templateUrl: './sidebar.component.html',
})
export class AppHorizontalSidebarComponent implements OnInit {
  navItems: NavItem[] = [];

  mobileQuery: MediaQueryList;
  private _mobileQueryListener: () => void;
  authSessionDto: AuthSessionDto;
  ROLE_WORKSPACE_USER = ROLE_WORKSPACE_USER;

  constructor(
    public navService: NavService,
    public router: Router,
    sidebarService: SidebarService,
    media: MediaMatcher,
    changeDetectorRef: ChangeDetectorRef,
    authService: AuthService,
  ) {
    this.navItems = sidebarService.getNavItems();
    this.mobileQuery = media.matchMedia('(min-width: 1100px)');
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);

    this.authSessionDto = authService.authenticatedSession$.value!;
  }

  ngOnInit(): void {}
}
